export default (state) => {
    return state.qrCode;
}



// WEBPACK FOOTER //
// ./src/ReduxRequests/State/qrCodeState.ts